import { render, staticRenderFns } from "./EditInterface.vue?vue&type=template&id=ffa1b934&scoped=true&"
import script from "./EditInterface.vue?vue&type=script&lang=ts&"
export * from "./EditInterface.vue?vue&type=script&lang=ts&"
import style0 from "./EditInterface.vue?vue&type=style&index=0&id=ffa1b934&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa1b934",
  null
  
)

export default component.exports